<template>
	<div class="customBreadcrumb displayF weight_400 fontSize16 color_B2B lineHeight16 "
		:class="!noMargin ? 'marginBottom16' : ''">
		<div @mousedown="(i + 1 != breadcrumbs.length) ? mousedownCommon($event) : mousedownCommon($event, 1)"
			@click="breadcrumbHandle(item, (i + 1 != breadcrumbs.length))"
			:class="'displayF alignItemsC columnGap8 cursor widthPercentage ' + (i + 1 == breadcrumbs.length ? 'color_FFF weight_bold' : 'color_B9B cursor')"
			v-for="(item, i) in breadcrumbs" :key="i">
			<img :src="initThemeImg(theme, isCustom ? 'icon-back-custom@2x' : 'icon-back@2x')" alt="" class="imgWH16">

			<span class="overflowH widthPer33 whiteSpaceN">
				{{route.query.pageType == 'uploadQueuePage' ? '上传队列' : item.name}}
			</span>
			<!-- <img v-if="i == 0 && breadcrumbs.length > 2" :src="initThemeImg(theme, 'icon-slash@2x')" alt=""
				class="imgWH16">
			<img v-if="i + 1 != breadcrumbs.length && !(i == 0 && breadcrumbs.length > 2)"
				:src="initThemeImg(theme, 'icon-slash@2x')" alt="" class="imgWH16"> -->
		</div>
	</div>
</template>

<script setup>
	import {
		onMounted
	} from 'vue'
	import {
		initThemeImg,
		mousedownCommon,
		goBackCommonHandle,
		globalCacheDeleteApi
	} from '@/utils/common'
	import useUserStore from '@/store/modules/user'
	const route = useRoute()
	const router = useRouter()
	const props = defineProps({
		breadcrumbs: {
			type: Array,
			default: () => [],
		},
		noMargin: {
			type: Boolean,
			default: false
		},
		cacheObj: {
			type: Object,
			default: null,
		},
		isCustom: {
			type: Boolean,
			default: false
		} // 生成器页面时 自定义混色样式
	})
	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})

	// ***这里需要暴露出去不然父组件调用不到这个方法
	defineExpose({
		breadcrumbHandle
	})

	// 面包屑点击(只展示父级项)
	function breadcrumbHandle(item, status, back) {
		const local = window.location
		const search = local.search
		const pathname = local.pathname

		console.log(status, 'status item.path', item.path)
		// 不是当前项 有点击事件
		// if (status) {
		// 	if (item.path) {
		// 		router.push(item.path)
		// 	} else {
		// 		// 公共返回方法
		// 		goBackCommonHandle()
		// 	}
		// }

		console.log(route, route.query.isParentUrl, back, props.cacheObj, 'routeroute')

		// 复制链接跳转时 点击返回跳转至首页
		if ((route.query.params && JSON.parse(route.query.params).isCopy) || route.query.isCopy) {
			// 有缓存时 删除对应缓存数据
			if (props.cacheObj) {
				// alert(111)
				globalCacheDeleteApi(props.cacheObj.cacheType, props.cacheObj.level)
			} else {
				// 20260409 新增 复制链接的返回 返回后需要跳转至项目中心页（删除项目中心缓存）
				// 项目追踪--模块详情--创建需求时 点击返回--删除项目追踪所有缓存
				globalCacheDeleteApi('project_centre', 0)
			}

			// 20260409 注释
			// router.push('/dashboard')
			// 20260409 新增 复制点击返回 跳转至项目中心页  并选中对应的项目id
			var id = null
			if (pathname.includes('/moduleAndRequirementCreateAndEditAndDetails')) {
				// 模块/需求详情时
				id = JSON.parse(route.query.params).projectId
			} else {
				// 项目介绍时
				id = route.query.id
			}

			if (id) {
				localStorage.setItem('projectIdIsCopy', id)
				router.push('/projectCenter')
			}
		} else if (route.query.isParentUrl) {
			// 新页面模式跳转--点击返回/取消/或者保存返回时调用
			router.push('/' + route.query.isParentUrl)
			return
		} else {
			console.log(router, route, 'router, route')
			// 页面内查看时 直接返回
			if (back) {
				// alert(back)
				router.go(back)
			} else {
				// 公共返回方法
				goBackCommonHandle('', props.cacheObj)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.customBreadcrumb {

		.widthPer33 {
			width: 33.33%;
		}
	}
</style>